(function (scope, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!scope || !scope.document || scope.__realmCartDiscountPresentation) return;
  scope.__realmCartDiscountPresentation = api;
  api.boot(scope.document, scope);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  var FORM = '[data-realm-checkout-form]';
  var MESSAGE = '.cbb-frequently-bought-discount-applied-message';
  var ALLOCATION = '[data-realm-bundle-allocation-total]';
  var ORIGINAL = 'Bundle discount will be applied at checkout';
  function allocations(form) {
    var nodes = Array.from(form.querySelectorAll(ALLOCATION)), total = 0, currency, label;
    if (!nodes.length) return null;
    for (var node of nodes) {
      var kind = node.getAttribute('data-realm-bundle-allocation-kind');
      var list = kind === 'line' ? '.realm-cart-line-discounts' : kind === 'cart' ? '.realm-cart-discounts' : null;
      if (!list || !node.closest(list) || node.closest(FORM) !== form) return null;
      var raw = node.getAttribute('data-realm-bundle-allocation-total');
      var amount = /^\d+$/.test(raw || '') ? Number(raw) : NaN;
      var nextCurrency = node.getAttribute('data-realm-bundle-allocation-currency');
      var nextLabel = node.getAttribute('data-realm-bundle-savings-applied-label');
      if (!Number.isSafeInteger(amount) || amount <= 0 || !/^[A-Z]{3}$/.test(nextCurrency || '') || !nextLabel || nextLabel.split('__amount__').length !== 2) return null;
      if (currency && currency !== nextCurrency || label && label !== nextLabel) return null;
      currency = nextCurrency; label = nextLabel; total += amount;
      if (!Number.isSafeInteger(total)) return null;
    }
    return { amount: total, currency: currency, label: label };
  }
  function Presenter(document, window) {
    this.document = document; this.window = window;
    this.originals = new WeakMap(); this.awaitingRender = new WeakSet(); this.renderedForms = new WeakMap();
  }
  Presenter.prototype.pendingMutations = function (records) {
    var self = this;
    Array.from(records || []).forEach(function (record, index, entries) {
      if (record.type !== 'attributes' || record.attributeName !== 'aria-busy' || !record.target.hasAttribute('data-cart-content')) return;
      var next = entries.slice(index + 1).find(function (entry) { return entry.type === 'attributes' && entry.attributeName === record.attributeName && entry.target === record.target; });
      var value = next ? next.oldValue : record.target.getAttribute('aria-busy');
      if (value !== 'true' || record.oldValue === 'true') return;
      Array.from(record.target.querySelectorAll(FORM)).forEach(function (form) { self.awaitingRender.add(form); self.renderedForms.delete(form); });
    });
  };
  Presenter.prototype.confirmed = function (event) {
    if (this.observer && this.observer.takeRecords) this.pendingMutations(this.observer.takeRecords());
    var self = this, detail = event && event.detail, cart = detail && detail.cart, valid = false;
    if (!detail || typeof detail.rendered !== 'boolean') return;
    if (detail.rendered === true) {
      try {
        var commerce = this.window.RealmCommerce;
        valid = !!(commerce && commerce.validCart && commerce.validCart(cart) === cart && /^[A-Z]{3}$/.test(cart.currency || '') && Number.isSafeInteger(cart.total_discount) && cart.total_discount >= 0);
      } catch (_) {}
    }
    Array.from(this.document.querySelectorAll(FORM)).forEach(function (form) {
      var snapshot = valid && allocations(form);
      self.awaitingRender.add(form); self.renderedForms.delete(form);
      if (snapshot && snapshot.currency === cart.currency && snapshot.amount <= cart.total_discount) self.renderedForms.set(form, { signature: JSON.stringify(snapshot), nodes: Array.from(form.querySelectorAll(ALLOCATION)) });
    });
  };
  Presenter.prototype.refresh = function () {
    var self = this;
    Array.from(this.document.querySelectorAll(FORM)).forEach(function (form) {
      var content = form.closest('[data-cart-content]');
      if (!content) return;
      var busy = content.getAttribute('aria-busy') === 'true', currentSnapshot = allocations(form), rendered = self.renderedForms.get(form);
      if (busy) self.awaitingRender.add(form);
      else if (rendered) {
        self.renderedForms.delete(form);
        var nodes = Array.from(form.querySelectorAll(ALLOCATION));
        if (JSON.stringify(currentSnapshot) === rendered.signature && nodes.length === rendered.nodes.length && nodes.every(function (node, index) { return node === rendered.nodes[index]; })) self.awaitingRender.delete(form);
      }
      var snapshot = busy || self.awaitingRender.has(form) ? null : currentSnapshot, applied = null;
      if (snapshot) {
        try {
          var locale = self.document.documentElement && self.document.documentElement.lang || self.window.RealmTheme && self.window.RealmTheme.locale || undefined;
          var amount = new Intl.NumberFormat(locale, { style: 'currency', currency: snapshot.currency }).format(snapshot.amount / 100);
          applied = snapshot.label.replace('__amount__', amount);
        } catch (_) {}
      }
      Array.from(form.querySelectorAll(MESSAGE)).forEach(function (message) {
        if (message.closest(FORM) !== form) return;
        var previous = self.originals.get(message), current = String(message.textContent || '');
        if (!previous || current !== previous.applied && current !== previous.original) {
          previous = { original: current, applied: null }; self.originals.set(message, previous);
        }
        var recognized = previous.original.trim().replace(/\s+/g, ' ') === ORIGINAL;
        var next = recognized && applied || previous.original;
        if (current !== next) message.textContent = next;
        previous.applied = recognized && applied || null;
        if (previous.applied) {
          if (message.getAttribute('data-realm-bundle-presentation') !== 'applied') message.setAttribute('data-realm-bundle-presentation', 'applied');
        } else if (message.hasAttribute('data-realm-bundle-presentation')) message.removeAttribute('data-realm-bundle-presentation');
      });
    });
  };
  function boot(document, window) {
    var presenter = new Presenter(document, window), queued = false;
    function refresh() {
      if (queued) return;
      queued = true;
      var queue = window.queueMicrotask || function (work) { Promise.resolve().then(work); };
      queue(function () { queued = false; presenter.refresh(); });
    }
    presenter.refresh();
    document.addEventListener('realm:cart-confirmed', function (event) { presenter.confirmed(event); refresh(); });
    document.addEventListener('shopify:section:load', refresh);
    window.addEventListener('pageshow', refresh);
    if (window.MutationObserver) {
      presenter.observer = new window.MutationObserver(function (records) { presenter.pendingMutations(records); refresh(); });
      presenter.observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeOldValue: true, attributeFilter: ['aria-busy', 'data-realm-bundle-allocation-total', 'data-realm-bundle-allocation-currency'] });
    }
    return presenter;
  }
  return { allocations: allocations, Presenter: Presenter, boot: boot };
});
